import { fn } from '@ember/helper';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import {
  PrismComboSelectInput,
  PrismInput,
  PrismSelectInput,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralFormFieldsCancelAndConfirm from 'lumen/components/general/form-fields/cancel-and-confirm';

interface ParityParityManagerAdditionalInfoFormSignature {
  Args: {
    back: unknown;
    issue: unknown;
    next: unknown;
    parentController: unknown;
    setIssueProperty: unknown;
    setIssuePropertyFromEvent: unknown;
  };
}

export default class ParityParityManagerAdditionalInfoForm extends Component<ParityParityManagerAdditionalInfoFormSignature> {
  @cached
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get possibleAssigneeOptions() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.args.parentController.possibleAssignees.map((assignee) => ({
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      label: assignee.name,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      assignee,
    }));
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get possibleAssigneeValue() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.possibleAssigneeOptions.find(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (option) => option.assignee === this.args.issue.assignee,
    );
  }

  @cached
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get possibleRootcausesWithoutDefaultOptions() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.args.parentController.possibleRootcausesWithoutDefault.map(
      // @ts-expect-error: Incorrect type
      (rootCause) => ({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        label: rootCause.name,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        rootCause,
      }),
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get possibleRootcausesWithoutDefaultValue() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.possibleRootcausesWithoutDefaultOptions.find(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (option) => option.rootCause === this.args.issue.root_cause,
    );
  }

  @cached
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get possibleStatusOptions() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.args.parentController.possibleStatuses.map((status) => ({
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      label: status.name,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      status,
    }));
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get possibleStatusValue() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.possibleStatusOptions.find(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (option) => option.status === this.args.issue.status,
    );
  }

  @action
  // @ts-expect-error: Incorrect type
  handlePossibleAssigneeChange(option): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.setIssueProperty('assignee', option.assignee);
  }

  @action
  // @ts-expect-error: Incorrect type
  handlePossibleRootcausesWithoutDefaultChange(option): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.setIssueProperty('root_cause', option.rootCause);
  }

  @action
  // @ts-expect-error: Incorrect type
  handlePossibleStatusChange(option): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.setIssueProperty('status', option.status);
  }

  <template>
    {{! @glint-nocheck }}
    <div class="pt-400 pr-500 pb-800 pl-500" id="add-issue-form">
      <h2 class="header-title">{{t "parity_manager.add_issue.other_info"}}</h2>
      <div class="mt-400 flex w-full flex-col">
        <label class="input-label">
          {{t "parity_manager.assignee"}}
        </label>
        <PrismComboSelectInput
          @isSearchable={{true}}
          @isSecondary={{true}}
          @onChange={{this.handlePossibleAssigneeChange}}
          @options={{this.possibleAssigneeOptions}}
          @placeholder={{t "general.dropdown.email_search"}}
          @value={{this.possibleAssigneeValue}}
        />
      </div>

      <div class="mt-400 flex w-full flex-col">
        <label class="input-label">
          {{t "parity_manager.issue.action.status"}}
        </label>
        <PrismSelectInput
          @isSecondary={{true}}
          @onChange={{this.handlePossibleStatusChange}}
          @options={{this.possibleStatusOptions}}
          @placeholder={{t "general.dropdown.select_status"}}
          @value={{this.possibleStatusValue}}
        />
      </div>

      <div class="mt-400 flex w-full flex-col">
        <label class="input-label">
          {{t @parentController.rootCauseOrWholesalerTitle}}
        </label>
        <PrismComboSelectInput
          @isSearchable={{true}}
          @isSecondary={{true}}
          @onChange={{this.handlePossibleRootcausesWithoutDefaultChange}}
          @options={{this.possibleRootcausesWithoutDefaultOptions}}
          @placeholder={{t @parentController.rootCauseOrWholesalerPlaceholder}}
          @value={{this.possibleRootcausesWithoutDefaultValue}}
        />
      </div>

      {{#unless @parentController.isBaitAndSwitchView}}
        <div class="mt-400 flex w-full flex-col">
          <PrismInput
            @label={{t "general.rate_code"}}
            @onInput={{fn @setIssuePropertyFromEvent "rate_code"}}
            @value={{@issue.rate_code}}
          />
        </div>
      {{/unless}}

      <div
        class="flex w-full flex-col
          {{if @parentController.isBaitAndSwitchView 'mt-400'}}"
      >
        <label class="input-label">
          {{t "parity_manager.issue.action.comment"}}
        </label>
        <PrismInput
          @onInput={{fn @setIssuePropertyFromEvent "comment"}}
          @placeholder={{t "parity_manager.form.comment"}}
          @removePadding={{true}}
          @rows={{4}}
          @textarea={{true}}
          @value={{@issue.comment}}
        />
      </div>
    </div>

    <div class="settings-modal__footer flex flex-row justify-end">
      <GeneralFormFieldsCancelAndConfirm
        @cancel={{@back}}
        @cancelText={{t "general.back"}}
        @confirm={{@next}}
        @confirmText={{t "parity_manager.attachments.continue"}}
      />
    </div>
  </template>
}
